import { render, staticRenderFns } from "./diseaseTypeNewNav.vue?vue&type=template&id=5bb9b739"
import script from "./diseaseTypeNewNav.vue?vue&type=script&lang=js"
export * from "./diseaseTypeNewNav.vue?vue&type=script&lang=js"
import style0 from "./diseaseTypeNewNav.vue?vue&type=style&index=0&id=5bb9b739&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports